import React, { useEffect, useState } from "react";
import styles from "./ProgramBanner.module.css";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Image from "next/image";
import { useRouter } from "next/router";
import CustomiseCta from "../CustomiseCta/CustomiseCta";

type ImageType = {
  id?: number;
  documentId?: string;
  url?: string;
  alternativeText?: string;
};

type ProgramBannerProps = {
  data: {
    cta: any;
    card_with_image: {
      title_description?: {
        title?: string;
        description?: string;
      };
      images?: ImageType[];
    };
  };
};

const ProgramBanner: React.FC<ProgramBannerProps> = ({ data }) => {
  const router = useRouter();
  const [pageSlug, setPageSlug] = useState("");

  useEffect(() => {
    const slug = router?.asPath?.split("/")?.filter(Boolean)?.join("/");
    setPageSlug(slug || "home");
  }, [router.asPath]);

  const { title_description, images } = data?.card_with_image || {};

  return (
    <>
      <div className={styles.bannerContainer}>
        <div className="container">
          <div className={styles.bannerContent}>
            <div className={styles.breadcrumb}>
              <Breadcrumbs />
            </div>
            <h1 className={styles.title}>{title_description?.title}</h1>
            <p className={styles.description}>
              {title_description?.description}
            </p>
            <div className={styles.imagesContainer}>
              {images?.map((image) =>
                image?.url ? (
                  <Image
                    key={image?.id}
                    src={image?.url}
                    alt={image?.alternativeText || "Program image"}
                    title={image?.alternativeText || "Program image"}
                    className={styles.image}
                    width={136}
                    height={60}
                    style={{
                      width: 136,
                      height: 60,
                      aspectRatio: 136 / 60,
                    }}
                  />
                ) : null
              )}
              {data?.cta && (
                <div className={styles.mobileEnquire}>
                  <div className={styles.contactButton}>
                    <CustomiseCta
                      ctaData={data?.cta}
                      pageSlug={pageSlug}
                      isProgramPage="contact"
                    />
                  </div>
                </div>
              )}
            </div>{" "}
            <div className={styles.FormSpace}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgramBanner;
